import { select } from 'redux-saga/effects';
import * as chimeActions from 'store/chime/chimeActions';
import { put } from 'store/utils';
import * as classroomActions from './classroomActions';

export function* recordSaga() {
  yield put(classroomActions.initAction({ key: 'recordMeeting' }));
  try {
    const { audioVideo } = yield select(({ chime }) => ({
      audioVideo: chime.audioVideo,
    }));

    // audioVideo.chooseVideoInputDevice(currentVideoInputDevice)
    // yield put(videoActions.toggleVideoAction())

    audioVideo.start();
    yield put(chimeActions.setHasJoinedAction({ hasJoined: true }));

    yield put(classroomActions.successAction({ key: 'recordMeeting' }));
  } catch (error) {
    yield put(classroomActions.errorAction({ key: 'recordMeeting', error }));
  }
}
